import React from 'react';

import Popover, { PopoverProps } from '@mui/material/Popover';
import Stack from '@mui/material/Stack';

import { NavItem } from '../../../nav';
import { AvatarPopoverMenu } from './AvatarPopoverMenu';

type Props = {
  closePopover: () => void;
  openItems: NavItem[];
  showSubMenu: (navItem: NavItem, level: number, el: any) => void;
} & Omit<PopoverProps, 'children'>;

export function AvatarPopover(props: Props) {
  const { closePopover, openItems = [], showSubMenu, ...others } = props;
  return (
    <Popover
      {...others}
      // PaperProps={{}}
      anchorOrigin={{
        horizontal: -16,
        vertical: 'top',
      }}
      elevation={3}
      marginThreshold={0}
      onClose={closePopover}
      transformOrigin={{
        horizontal: 'right',
        vertical: 'top',
      }}
    >
      <Stack direction="row-reverse" sx={{ maxHeight: 'calc(100vh - 100px)' }}>
        {openItems.map((openItem, index) => {
          const level = index + 1;
          return (
            <AvatarPopoverMenu
              closePopover={closePopover}
              data-testid={`${openItem.key}`}
              key={openItem.key}
              level={level}
              navItem={openItem}
              showSubMenu={showSubMenu}
            />
          );
        })}
      </Stack>
    </Popover>
  );
}
